module.exports = __webpack_public_path__ + "static/media/features-ic-02.9c154b26.svg";